import React, { memo, useCallback } from 'react';
import ReactResizeObserver from '../../../es/_util/resizeObserver';
const ResizeObservedRow = function ResizeObservedRow(props) {
    const { children, onResize, rowIndex } = props;
    const handleResize = useCallback((_width, height, target) => {
        onResize(rowIndex, height, target);
    }, [onResize, rowIndex]);
    return (React.createElement(ReactResizeObserver, { resizeProp: "height", onResize: handleResize, immediately: true }, children));
};
ResizeObservedRow.displayName = 'ResizeObservedRow';
export default memo(ResizeObservedRow);
